<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

  <div class="flex flex-wrap xl:flex-nowrap flex-col sm:flex-row sm:justify-between sm:items-center gap-2">

    <div class="flex flex-wrap flex-col sm:flex-row gap-2">

      <!-- search -->
      <div class="min-w-48 relative">
        <input [(ngModel)]="search" class="pl-8" (input)="onSearchInput()"type="text" placeholder="Search.." />
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </div>

       <!-- Date picker -->
        <div class="min-w-48">
          <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date" [readOnly]="true"
            (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" />
          <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
        </div>

  </div>
  <div *ngIf="filterdataList && filterdataList.length">
    <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (filterdataList !=
      numberOfRecords? (numberOfRecords
      -filterdataList.length) : 0) }} of {{totalResults }} entries
    </h1>
  </div>
        <div></div>
  </div>
  <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full table-auto">
              <thead>
                <tr>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    #</th>
              
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Action</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Reference ID
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Association
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Funding Source
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Member</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Contact No.</th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Pickup Time
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Dropoff Time
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Pickup Address</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Dropoff Address</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    LOS</th>
                 
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Created At </th>
                    <th 
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Status </th>
             
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    General Notes</th>
                    
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let trip of filterdataList  | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i = index;"
                  class="hover:bg-gray-950/5 dark:hover:bg-white/10">

                     <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{i+1}}
                  </td>
                  <!-- actions -->
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <div class="flex">
                      <button  [appToolTip]="'Notes'" (click)="openNotesModal(trip)"
                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
                          class="h-5 w-5">
                          <path fill="currentColor"
                            d="M7.154 13.539q.31 0 .54-.23q.229-.23.229-.54t-.23-.54t-.54-.229t-.538.23t-.23.54q0 .309.23.539t.539.23m0-2.77q.31 0 .54-.23q.229-.23.229-.539t-.23-.54t-.54-.23t-.538.23t-.23.54t.23.54t.539.23m0-2.77q.31 0 .54-.23t.229-.54t-.23-.539t-.54-.23t-.538.23t-.23.54t.23.54t.539.229m3.077 5.27H14.5v-1h-4.27zm0-2.77H17.5v-1h-7.27zm0-2.77H17.5v-1h-7.27zM3 20.078V4.616q0-.691.463-1.153T4.615 3h14.77q.69 0 1.152.463T21 4.616v10.769q0 .69-.463 1.153T19.385 17H6.077zM5.65 16h13.735q.23 0 .423-.192t.192-.423V4.615q0-.23-.192-.423T19.385 4H4.615q-.23 0-.423.192T4 4.615v13.03zM4 16V4z" />
                        </svg>
                      </button>
                      <ng-container *ngIf="trip.status !== 'created'">
                      <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                      <button  [appToolTip]="'Edit'" (click)="createTrip(trip)" class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400" aria-label="Assign Trip">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                          class="w-5 h-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                        </svg>
                      </button>
                      </ng-container>
                    </div>
                  
                  </td>
            
                  <!-- Reference -->
                   <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span>
                     {{ trip.reference || 'N/A' }}{{trip.suffix ? '-' + trip.suffix : '' }}
                    </span>
                  </td>
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span>
                      {{trip.association || 'N/A'}}
                    </span>
                  </td>
                  <!-- --Funding Source-- -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span *ngIf="preFundingSource && trip.fundingsource">
                      {{preFundingSource[trip.fundingsource]?.title | titlecase}}
                    </span>
                  </td>
                  <!-- member -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <span *ngIf="trip?.member; else elseBlock">
                      {{trip?.member?.displayName | titlecase}}
                    </span>
                  </td>
                  <!-- phoneNumber -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap" phoneNumberFormat [phoneNumber]="trip?.member?.contactNumber">
                    {{ trip?.member?.contactNumber || 'N/A'}}
                  </td>
                  <!-- pickuptime -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div class="flex flex-col gap-0 leading-tight">
                      <span>{{trip?.pickup?.time | date: 'MM/DD/YYYY HHmm'}}</span>
                      <!-- <ng-container *ngIf="isShowTime" >
                        <span class="text-orange-700" *ngIf="trip.member && trip.member.timeZone">
                          (Member: {{ trip?.pickup?.time | date:'MM/DD/YYYY HHmm' : trip.member.timeZone || 'N/A'}})
                        </span>
                        <span class="text-green-700"
                          *ngIf="trip.fundingsource && preFundingSource[trip.fundingsource] && preFundingSource[trip.fundingsource].timeZone">
                          (FS: {{ trip?.pickup?.time | date:'MM/DD/YYYY HHmm' : preFundingSource[trip.fundingsource].timeZone || 'N/A' }})
                        </span>
                      </ng-container> -->
                    </div>
                  </td>
                  <!-- DO time -->
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div class="flex flex-col gap-0 leading-tight">
                      <span>{{trip?.destination?.time | date: 'MM/DD/YYYY HHmm'  }}</span>
                      <!-- <ng-container *ngIf="isShowTime">
                        <span class="text-orange-700" *ngIf="trip.member && trip.member.timeZone">
                          (Member: {{ trip?.pickup?.time | date:'MM/DD/YYYY HHmm' : trip.member.timeZone }})
                        </span>
                        <span class="text-green-700"
                          *ngIf="trip.fundingsource && preFundingSource[trip.fundingsource] && preFundingSource[trip.fundingsource].timeZone">
                          (FS: {{ trip?.destination?.time | date:'MM/DD/YYYY HHmm' : preFundingSource[trip.fundingsource].timeZone }})
                        </span>
                      </ng-container> -->
                    </div>
                  </td>
                  <!-- pickup address -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{trip?.pickup?.address?.name || 'N/A'}}</td>
                  <!-- destination address -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{trip?.destination?.address?.name || 'N/A'}}</td>
             
                  <!-- LOS -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                <span *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService];else elseBlock">
                      {{preLevelOfService[trip.levelOfService].title | uppercase}}
                    </span>
                  </td>
                
                
                  <!-- createdAt -->
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    {{trip.createdAt | date: 'MM/DD/YYYY HHmm'}}</td>
                    <td 
                    class=" px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                    <div [ngClass]="{
                                          'badge-danger': trip?.status === 'cancelled' || trip?.status === 'reroute',
                                          'badge-success': trip?.status !== 'cancelled' && trip?.status !== 'reroute'
                                        }">
                    {{trip.status | titlecase  }}
                    </div>
                  </td>
                  <td
                    class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 ">
                   <div *ngIf="trip.generalNotes; else elseBlock" class="w-72 line-clamp-2 white-space: pre-line">
                     <span [innerHTML]="breakString(trip.generalNotes)"></span>
                    </div>
                  </td> 
                </tr>
              </tbody>
            </table>
            <ng-template #elseBlock>N/A</ng-template>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end">
      <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>
    
  </div>


</section>

<app-notes-modal *ngIf="memberNotesObj" [source]="'staging'" [notes]="memberNotesObj" (closeModal)="memberNotesObj = null"></app-notes-modal>
